import React, { useState, useEffect } from "react";
import { staffApi } from "../../../../../services";
import TransactionTable from "../../../../../components/transactions/TransactionTable";
import TransactionSummary from "../../../../../components/transactions/TransactionSummary";

const MyTransactions = ({ type }) => {
  const [transactions, setTransactions] = useState([]);
  const [summary, setSummary] = useState({ totalCredit: 0, totalDebit: 0 });
  const [loading, setLoading] = useState(false);

  const fetchTransactions = async () => {
    try {
      setLoading(true);

      const { data } = await staffApi.getMyTransactions(type);

      if (!data.success) throw new Error(data.message);

      const txns = data.data.map((txn) => ({
        id: txn._id,
        customer: txn.userId?.name,
        phone: txn.userId?.phone,
        accountNumber: txn.accountNumber,
        type: txn.type,
        amount: txn.amount,
        date: txn.createdAt,
        balance: txn.newBalance,
      }));

      setTransactions(txns);

      const totalCredit = txns
        .filter(t => t.type === "credit")
        .reduce((sum, t) => sum + t.amount, 0);

      const totalDebit = txns
        .filter(t => t.type === "debit")
        .reduce((sum, t) => sum + t.amount, 0);

      setSummary({ totalCredit, totalDebit });
    } catch (err) {
      alert(err.response?.data?.message || err.message || "Error fetching transactions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [type]);

  return (
    <div>
      <h3>My Transactions ({type})</h3>

      {loading && <p>Loading...</p>}

      {!loading && (
        <>
          <TransactionSummary summary={summary} />
          <TransactionTable transactions={transactions} />
        </>
      )}
    </div>
  );
};

export default MyTransactions;

